"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABTestClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class ABTestClient extends authenticated_client_1.AuthenticatedClient {
    getConfiguration(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/abtest`);
            return response.payload;
        });
    }
    getSites(projectIdOrSiteRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = typeof projectIdOrSiteRequest === 'number'
                ? yield this.httpGet(`/v1/projects/${projectIdOrSiteRequest}/abtest/sites`)
                : yield this.httpPost(`/v2/projects/${projectIdOrSiteRequest.projectId}/abtest/sites`, {
                    provider: projectIdOrSiteRequest.provider,
                    metadata: projectIdOrSiteRequest.metadata,
                });
            return response.payload;
        });
    }
    getExperiments(projectId, params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!params) {
                params = {};
            }
            else if (typeof params === 'string') {
                params = { textSearch: params };
            }
            const queryString = this.getQueryString(params);
            const response = yield this.httpGet(`/v1/projects/${projectId}/abtest/experiments?${queryString}`);
            return response.payload;
        });
    }
    getExperiment(projectId, experimentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/abtest/experiments/${experimentId}`);
            return response.payload;
        });
    }
    getVariations(projectId, experimentId, pageId, textSearch) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = this.getQueryString({ textSearch, pageId });
            const response = yield this.httpGet(`/v1/projects/${projectId}/abtest/experiments/${experimentId}/variations?${queryString}`);
            return response.payload;
        });
    }
    getVariationsV2(projectId, experimentId, previewUrl, textSearch) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = this.getQueryString({ textSearch, previewUrl });
            const response = yield this.httpGet(`/v2/projects/${projectId}/abtest/experiments/${experimentId}/variations?${queryString}`);
            return response.payload;
        });
    }
    getVariation(projectId, experimentId, variationId, pageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = this.getQueryString({ pageId });
            const response = yield this.httpGet(`/v1/projects/${projectId}/abtest/experiments/${experimentId}/variations/${variationId}?${queryString}`);
            return response.payload;
        });
    }
    getVariationSegment(projectId, experimentId, variationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/abtest/experiments/${experimentId}/variations/${variationId}/segment`);
            return response.payload;
        });
    }
}
exports.ABTestClient = ABTestClient;
//# sourceMappingURL=abtests.client.js.map